import type { InjectionKey } from 'vue'
import type { UIDialogInstance } from '../types'

export const UIDIALOG_KEY = Symbol() as InjectionKey<UIDialogInstance>
